"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.returnsAddressSchema = returnsAddressSchema;
const zod_1 = require("zod");
const ZIP_DE_LENGTH = 5;
const ZIP_NON_DE_MAX = 17;
function returnsAddressSchema({ translatedStrings, }) {
    const required = translatedStrings.requiredField;
    return zod_1.z
        .object({
        additionalInfo: zod_1.z
            .string()
            .max(35, translatedStrings.maxCharsN(35))
            .optional(),
        city: zod_1.z
            .string({ error: () => required })
            .min(1, required)
            .max(35, translatedStrings.maxCharsN(35)),
        countryCode: zod_1.z.string({ error: () => required }).min(1, required),
        name: zod_1.z
            .string({ error: () => required })
            .min(1, required)
            .max(35, translatedStrings.maxCharsN(35)),
        streetAddress: zod_1.z
            .string({ error: () => required })
            .min(1, required)
            .max(40, translatedStrings.maxCharsN(40)),
        zip: zod_1.z.string({ error: () => required }).min(1, required),
    })
        .superRefine((data, ctx) => {
        if (data.countryCode === 'DE') {
            if (data.zip.length < ZIP_DE_LENGTH) {
                ctx.addIssue({
                    code: 'custom',
                    message: translatedStrings.nCharsField(ZIP_DE_LENGTH),
                    path: ['zip'],
                });
            }
            else if (data.zip.length > ZIP_DE_LENGTH) {
                ctx.addIssue({
                    code: 'custom',
                    message: translatedStrings.maxCharsN(ZIP_DE_LENGTH),
                    path: ['zip'],
                });
            }
        }
        else if (data.zip.length > ZIP_NON_DE_MAX) {
            ctx.addIssue({
                code: 'custom',
                message: translatedStrings.maxCharsN(ZIP_NON_DE_MAX),
                path: ['zip'],
            });
        }
    });
}
//# sourceMappingURL=returns-address.js.map